import React from 'react';
import classNameBind from 'classnames/bind';
import Header from '../Header';
import styles from './DefinitionList.module.css';

const bindClasses = classNameBind.bind(styles);

const renderEmptyLabel = label => (
  <tr
    data-ppuc-id="DefinitionList.row.empty"
  >
    <td className={bindClasses('cell')}>
      {label}
    </td>
  </tr>
);

const DefinitionList = ({
  items,
  title,
  titleSize,
  textAlign,
  emptyLabel,
  noVerticalPaddings,
}) => (
  <table
    className={bindClasses('wrapper')}
    data-ppuc-id="DefinitionList"
  >
    {
      title && (
        <caption className={bindClasses('caption')}>
          <Header type={titleSize}>{title}</Header>
        </caption>
      )
    }
    <tbody>
      {items.length === 0
        ? renderEmptyLabel(emptyLabel)
        : items.map((item, index) => (
          <tr
            key={index}
            data-ppuc-id="DefinitionList.row"
            className={bindClasses('cellContainer', { noVerticalPaddings })}
          >
            <td
              className={bindClasses('cell', textAlign[0])}
              data-ppuc-id="DefinitionList.title"
            >
              {item.title}
            </td>
            <td
              className={bindClasses('cell', textAlign[1])}
              data-ppuc-id="DefinitionList.value"
            >
              {item.value}
            </td>
          </tr>
        ))}
    </tbody>
  </table>
);

DefinitionList.defaultProps = {
  items: [],
  title: '',
  titleSize: 'medium',
  textAlign: ['left', 'left'],
  emptyLabel: '',
  noVerticalPaddings: false,
};

export { DefinitionList };
